import { render, staticRenderFns } from "./ErrorSubmitForm7.vue?vue&type=template&id=64b56974&scoped=true"
import script from "./ErrorSubmitForm7.vue?vue&type=script&lang=ts"
export * from "./ErrorSubmitForm7.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b56974",
  null
  
)

export default component.exports